export const LOGOUT = 'LOGOUT';
export const LOGIN = 'LOGIN';
export const SHOW_ID = 'SHOW_ID';
export const ADD_TO_MY_LIST = 'ADD_TO_MY_LIST';
export const SIGN_IN_BLOCK = 'SIGN_IN_BLOCK';
